module.exports = __webpack_public_path__ + "static/Harjot_Dhaliwal.f611e09b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Harjot_Dhaliwal.jpg
// module id = 915
// module chunks = 146520050992020